
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Order } from "@/types/ApiTypes";
interface OrdersSearchDataState {
    ordersSearchData: Order | null; // Replace `any` with the actual data type if known
}

const initialState: OrdersSearchDataState = {
    ordersSearchData: null,
};

const ordersSearchDataSlice = createSlice({
    name: 'ordersSearchData',
    initialState,
    reducers: {
        setOrdersSearchData: (state, action: PayloadAction<Order>) => {
            // Save the fetched orders search data
            state.ordersSearchData = action.payload;
        },
        clearOrdersSearchData: (state) => {
            // Clear the stored orders search data
            state.ordersSearchData = null;
        },
    },
});

// Export actions to use in your components
export const { setOrdersSearchData, clearOrdersSearchData } = ordersSearchDataSlice.actions;

// Export the reducer to add to the store
export default ordersSearchDataSlice.reducer;
